import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { useAuth } from './useAuth.js';
import { db } from './firebase.js';

export function useStaffAccess() {
    const { currentUser, getIdTokenClaims, authMode, loading } = useAuth();
    const [access, setAccess] = useState({ loading: true, admin: false, owner: false, permissions: [] });
    useEffect(() => {
        if (loading) return;
        let cancelled = false; let unsubscribe;
        setAccess({ loading: true, admin: false, owner: false, permissions: [] });
        const finish = data => { if (!cancelled) setAccess({ loading: false, admin: false, owner: false, permissions: [], ...data }); };
        if (!currentUser) { finish({}); return; }
        if (authMode === 'mock') { finish({ admin: true, owner: true }); return; }
        getIdTokenClaims().then(claims => {
            if (cancelled) return;
            if (claims?.role === 'admin') finish({ admin: true, owner: claims.email_verified === true && claims.email?.toLowerCase() === 'learn@daniellenglish.com' });
            else if (claims?.email_verified === true && db) unsubscribe = onSnapshot(doc(db, 'staffAccess', currentUser.uid), snap => {
                const data = snap.data(); finish({ permissions: data?.enabled === true && Array.isArray(data.permissions) ? data.permissions : [] });
            }, () => finish({}));
            else finish({});
        }).catch(() => finish({}));
        return () => { cancelled = true; unsubscribe?.(); };
    }, [currentUser, loading, getIdTokenClaims, authMode]);
    return access;
}
